import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { buildAuthorshipAliasBlock } from '@next-adapter/generators/actions/action-helpers/build-authorship-alias-block.js'
import { renderGenGetByIdContentServerActionTemplate } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/gen-get-by-id-content.js'

export function genGetByIdContent(ctx: EntityCtx): string {
  const dbImports = [ctx.tableVar, 'user', ...ctx.relTableImports].sort()
  const drizzle: string[] = ['eq']
  const sortedDrizzle = [...new Set(drizzle)].sort()

  const byIdHelperImports: string[] = ['formatActionDate']
  if (ctx.hasSelectFields) byIdHelperImports.push(`resolve${ctx.Singular}SelectFields`)
  if (ctx.hasListRels) byIdHelperImports.push(`populate${ctx.Singular}ListRelationships`)
  if (ctx.hasMediaFields) byIdHelperImports.push(`resolve${ctx.Singular}MediaFields`)
  const populateImport =
    byIdHelperImports.length > 0
      ? `\nimport { ${byIdHelperImports.join(', ')} } from './helpers'`
      : ''

  return renderGenGetByIdContentServerActionTemplate({
    join: dbImports.join(', '),
    joinText: sortedDrizzle.join(', '),
    ctxCacheReadImport: ctx.cacheReadImport,
    ctxCamelPlural: ctx.camelPlural,
    ctxSingular: ctx.Singular,
    populateImport: populateImport,
    authorshipAliasBlock: buildAuthorshipAliasBlock(),
    ctxCacheLifeLine: ctx.cacheLifeLine,
    ctxSelectClause: ctx.selectClause,
    ctxTableVar: ctx.tableVar,
    ctxSingleRowReturn: ctx.singleRowReturn,
    ctxSingularText: ctx.singular
  })
}
